import { useTariffStore } from '@/store/tariffStore'
import { resolveFeatureGate } from '@/services/tariffs/tariffGateResolver'

export function useTariffGate(options = {}) {
    const store = useTariffStore()

    return resolveFeatureGate({
        ...options,
        accessMap: store.effectiveAccess,
        usageMap: store.featureUsage,
        isLoading: store.isInitialLoading,
    })
}
